import React from 'react';
import { Modal, Button, Badge, Spinner } from 'react-bootstrap';
import './ModalFusion.Module.css';
import toast from 'react-hot-toast';
import axios from 'axios';
import { getUsersLimit, searchAllUsers } from '../../../utils/users/users';
import UsersTable from '../../../routes/dashboard/usersTable/UsersTable';
import Pagination from '../../pagination/Pagination';

const ModalFusion = ({ show, handleClose, client }) => {
  const token = localStorage.getItem('Token');
  const config = { headers: { xtoken: `${token}` } };


  // form = quién se fusiona (idFusionar) -> client , y quién se conserva (idPrincipal) -> el que elijas en la tabla
  const [formData, setFormData] = React.useState({
    idFusionar: client?._id || '',
    idPrincipal: '',
    nombre: client?.nombre || '',
    apellido: client?.apellido || '',
    dni: client?.dni || '',
    correo: client?.correo || ''
  });

  React.useEffect(() => {
    setFormData({
      idFusionar: client?._id || '',
      idPrincipal: '',
      nombre: client?.nombre || '',
      apellido: client?.apellido || '',
      dni: client?.dni || '',
      correo: client?.correo || ''
    });
  }, [client]);


    console.log("client", client)
    console.log("formData", formData)

  // Estado Usuarios (listado + paginación + loading)
  const [terminoUsuario, setTerminoUsuario] = React.useState('');
  const [usuariosDesde, setUsuariosDesde] = React.useState(0);
  const [users, setUsers] = React.useState({ total: 0, usuarios: [] });
  const [loadingUsers, setLoadingUsers] = React.useState(false);
  const [saving, setSaving] = React.useState(false);

  const [paginaActualClientes, setPaginaActualClientes] = React.useState(1);
  const paginadoUsers = (numeroPagina) => {
    setPaginaActualClientes(numeroPagina);
    setUsuariosDesde(numeroPagina * 8 - 8);
  };

  // Selección de usuario "principal" (el que se conserva)
  const handleUserClick = (userId) => {
    setFormData((prev) => ({ ...prev, idPrincipal: userId._id }));
  };

  const handleSearchUser = (e) => {
    setUsuariosDesde(0);
    setPaginaActualClientes(1);
    setTerminoUsuario(e.target.value);
  };

  const handleModalSave = async () => {
    try {
      if (!formData.idPrincipal) {
        toast.error('Seleccioná el cliente que se conserva.');
        return;
      }
      if (formData.idPrincipal === formData.idFusionar) {
        toast.error('El cliente a conservar no puede ser el mismo que el que se fusiona.');
        return;
      }

      setSaving(true);
      await axios.post(
        `${process.env.REACT_APP_BACK_URL}/api/usuarios/fusionar`,
        {
          idPrincipal: formData.idPrincipal,
          idFusionar: formData.idFusionar
        },
        config
      );

      window.dispatchEvent(new Event('actualizar-cliente'));
      toast.success('Usuarios fusionados con éxito');

      setFormData({
        idFusionar: '',
        idPrincipal: '',
        nombre: '',
        apellido: '',
        dni: '',
        correo: ''
      });
      handleClose();
    } catch (error) {
      toast.error(error?.response?.data?.msg || 'Error al fusionar usuarios');
    } finally {
      setSaving(false);
    }
  };

  React.useEffect(() => {
    let cancelado = false;
    (async () => {
      try {
        setLoadingUsers(true);
        const data =
          terminoUsuario.trim() === ''
            ? await getUsersLimit(usuariosDesde, 8)
            : await searchAllUsers(terminoUsuario, usuariosDesde);
        if (!cancelado) setUsers(data || { total: 0, usuarios: [] });
      } catch (e) {
        if (!cancelado) setUsers({ total: 0, usuarios: [] });
      } finally {
        if (!cancelado) setLoadingUsers(false);
      }
    })();
    return () => {
      cancelado = true;
    };
  }, [usuariosDesde, terminoUsuario]);

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" size="xl" centered dialogClassName="modalFusionDialog">
      <Modal.Header className="headerModalHistorial" closeButton>
        <Modal.Title>Fusionar clientes</Modal.Title>
      </Modal.Header>

      <Modal.Body className="modalFusionBody">
        <div className="fusion-grid">
          {/* Columna izquierda: usuario a fusionar (read-only) */}
          <div className="leftPane">
            <h6 className="mb-3">
              Se <strong>fusiona</strong> este cliente
              <Badge bg="secondary" className="ms-2">
                ID: {formData.idFusionar?.slice(-6)}
              </Badge>
            </h6>

            <div className="card p-3">
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label">Nombre</label>
                  <input className="form-control" type="text" value={formData.nombre} disabled />
                </div>
                <div className="col-12">
                  <label className="form-label">Apellido</label>
                  <input className="form-control" type="text" value={formData.apellido} disabled />
                </div>
                <div className="col-md-6">
                  <label className="form-label">DNI</label>
                  <input className="form-control" type="text" value={formData.dni} disabled />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Correo</label>
                  <input className="form-control" type="text" value={formData.correo} disabled />
                </div>
              </div>
            </div>
          </div>

          {/* Columna derecha: selección del usuario a conservar */}
          <div className="rightPane">
            <h6 className="mb-3">
              Con este <strong>cliente</strong>
              {formData.idPrincipal && (
                <Badge bg="primary" className="ms-2">
                  Seleccionado: {formData?.idPrincipal?.slice(-6)}
                </Badge>
              )}
            </h6>

            <div className="mb-2">
              <input
                className="form-control"
                type="search"
                placeholder="Buscar cliente..."
                value={terminoUsuario}
                onChange={handleSearchUser}
              />
            </div>

            <div className="usersTableWrapper">
              {loadingUsers ? (
                <div className="d-flex align-items-center justify-content-center py-5">
                  <Spinner animation="border" role="status" />
                </div>
              ) : (
                <UsersTable
                  users={users.usuarios}
                  onUserClick={handleUserClick}
                  selectedId={formData.idPrincipal} // <- si podés, sumá este prop en UsersTable para resaltar la fila
                />
              )}
            </div>

            <div className="mt-2 d-flex justify-content-end">
              <Pagination
                key={paginaActualClientes}
                productosPorPagina={8}
                productos={users.total}
                paginado={paginadoUsers}
                paginaActual={paginaActualClientes}
              />
            </div>
          </div>
        </div>

        <div className="divMagicoReset py-2 mt-4 d-flex justify-content-end gap-2">
          <Button variant="secondary" onClick={handleClose} disabled={saving}>
            Cerrar
          </Button>
          <Button
            className="botonModalConfirmacion"
            variant="primary"
            onClick={handleModalSave}
            // disabled={saving || !formData.idPrincipal || formData.idPrincipal === formData.idFusionar}
            title={
              formData.idPrincipal === formData.idFusionar
                ? 'Elegí un cliente distinto al que se fusiona'
                : undefined
            }
          >
            {saving ? 'Fusionando...' : 'Fusionar'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalFusion;
